import React, { useEffect, useState, useRef } from "react";
import es_ES from "rsuite/locales/es_ES";
import {
  Accordion,
  Card,
  Text,
  Input as Inpt,
  Message,
  toaster,
  Button,
  IconButton,
  NumberInput,
  DatePicker,
  SelectPicker,
  Panel,
  Form,
  Carousel,
  Modal,
  List,
  Breadcrumb,
  Textarea,
  Checkbox,
  Drawer,
  HStack,
  CustomProvider,
  Box,
  InputGroup,
} from "rsuite";
import { Table as TableAntd, Input, notification, Button as Btn } from "antd";
import {
  getAntecedentes,
  getDatosCita,
  getDocsCita,
  getDatosCitaAnterior,
  getEstadoIMC,
  getExpedAnterior,
  getExploraFisicaItems,
  getHorariosDia,
  getPacienteProgramado,
  getHistoricoCitas,
  getSesionesHemo,
  saveConsulta,
  saveDoc,
  saveItem,
  addMarcador,
} from "../Services/ConsultasServices";
import {
  getCatDiagnosticos,
  getGruposLab,
  getMarcadoresLab,
} from "../Services/CatalogosServices";
import { getDatosPaciente } from "../Services/PacientesServices";
import { getCatServicios } from "../Services/HorariosServices";
import { useParams } from "react-router-dom";
import AttachmentIcon from "@rsuite/icons/Attachment";
import { LucideNotebookPen, LucideSave, LucideSearch, SearchIcon } from "lucide-react";
import { useReactToPrint } from "react-to-print";
import moment from "moment/moment";
import "moment/locale/es"; // Importante para el idioma español
import { VscEdit, VscSave } from "react-icons/vsc";
import Table from "react-bootstrap/Table";
import { confApp } from "../../CONF_APP";
import { LayoutHome } from "../LayoutHome";
import { FaArrowRight, FaNotesMedical, FaPlusCircle } from "react-icons/fa";
import ChangeListIcon from "@rsuite/icons/ChangeList";
import { NotaEvolucion } from "./NotaEvolucion";
import { render } from "@testing-library/react";
import { soloNumeros } from "../../Utils";
import { InputGroupText } from "reactstrap";

// const { Column, HeaderCell, Cell } = Table;

export const Consulta = (noEspacio) => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [appConfigParams] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp,
  );

  const idAnteced = appConfigParams.mostrarIdAntecedente;

  const [consultorio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );

  const [idMedico] = useState(
    JSON.parse(localStorage.getItem("auth")).idMedico,
  );
  const [medico] = useState(JSON.parse(localStorage.getItem("auth")).medico);

  const [fechaLarga] = useState(appConfigParams.fechas.fechaLarga);
  const [result, setResult] = useState({});
  const [listaSaturaOx] = useState(confApp.VALORES_SATURACION_OX);
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [paciente, setPaciente] = useState("");
  const [inicioDisabled, setInicioDisabled] = useState(false);
  const [idDiag, setIdDiag] = useState([]);
  const [fechaIni, setFechaIni] = useState("");

  const componentRef = useRef();
  const componentValorPreQX = useRef();
  const initialized = useRef(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const [espacio] = useState(noEspacio);

  const [mostrarModalPreQx, setMostrarModalPreQx] = useState(false);
  const [modalOpenValPreQx, setModalOpenValPreQx] = useState(false);
  const [file, setFile] = useState({});
  const [loaderDatos, setLoaderDatos] = useState(false);
  const [filtroDiag, setFiltroDiag] = useState("");
  const [listHorarios, setListHorarios] = useState([
    { label: "--SELECCIONA--", value: "0" },
  ]);
  const [data, setData] = useState([]);
  const [activeKey, setActiveKey] = useState(1);
  const [horario, setHorario] = useState("0");

  const [defaultExpanded] = useState(true);
  const [disabledAccord2, setDisabledAccord2] = useState(true);
  const [disabledAccord3, setDisabledAccord3] = useState(true);
  const [disabledIni, setDisabledIni] = useState(false);

  const [listaAnteced, setListaAnteced] = useState([
    { nombre: "", detalles: [] },
  ]);

  const { TextArea } = Input;
  const [dataSignos, setdataSignos] = useState([]);
  const [dataSignosEx, setdataSignosEx] = useState([]);

  const [valueGpo1, setValueGpo1] = useState("");
  const [valueGpo2, setValueGpo2] = useState("");
  const [valueGpo3, setValueGpo3] = useState("");
  const [valueGpo4, setValueGpo4] = useState("");

  const [diagnostico, setDiagnostico] = useState("");
  const [tratamiento, setTratamiento] = useState("");
  const [indicaciones, setIndicaciones] = useState("");

  const [idConsulta, setIdConsulta] = useState(0);
  const [diagnosticoCita, setDiagnosticoCita] = useState("");
  const [tratamientoCita, setTratamientoCita] = useState("");
  const [indicacionesCita, setIndicacionesCita] = useState("");
  const [observaCita, setObservaCita] = useState("");

  const [motivoEx, setMotivoEx] = useState("");
  const [diagnosticoCitaEx, setDiagnosticoCitaEx] = useState("");
  const [tratamientoCitaEx, setTratamientoCitaEx] = useState("");
  const [indicacionesCitaEx, setIndicacionesCitaEx] = useState("");
  const [observaCitaEx, setObservaCitaEx] = useState("");

  const [panelExpandedSignos, setPanelExpandedSignos] = useState(false);

  const [idTipoDoc, setIdTipoDoc] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabledUPload, setDisabledUpload] = useState(true);
  const [observa, setObserva] = useState("");
  const [listServicios, setListServicios] = useState([]);
  const [listCitas, setListCitas] = useState([{ label: "", vlaue: "" }]);
  const [listaExploraFis, setListaExploraFis] = useState([
    { label: "", vlaue: "" },
  ]);
  const [valoresChecked, setValoresChecked] = useState([]);
  const [listaTipoDocs, setListaTipoDocs] = useState([
    { label: "", value: "" },
  ]);
  const [disabledDiag, setDisabledDiag] = useState(true);
  const [disabledTrat, setDisabledTrat] = useState(true);
  const [disabledIndic, setDisabledIndic] = useState(true);

  const [telefono, setTelefono] = useState("");

  const [modalReceta, setModalReceta] = useState(false);
  const { idPaciente, idServicio, fecha, hora } = useParams();

  const [fileList, setFileList] = useState([]);
  const [imageList, setImageList] = useState([{ doc: "", tipoDoc: "" }]);

  const [motivoCons, setMotivoCons] = useState("");
  const [motivoConsEx, setMotivoConsEx] = useState("");
  const [linkDoc, setLinkDoc] = useState("#");

  const [open, setOpen] = useState(false);
  const [tituloDrawer, setTituloDrawer] = useState("");

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> VARIABLES PARA EXPLORACIÓN FISICA
  const [frecCardiaca, setFrecCardiaca] = useState("");
  const [frecResp, setFrecResp] = useState("");
  const [temp, setTemp] = useState("");
  const [presionArt, setPresioArt] = useState("");
  const [peso, setPeso] = useState("");
  const [talla, setTalla] = useState("");
  const [imc, setImc] = useState("");
  const [saturaOx, setSaturaOx] = useState("");
  const [glicemiaCap, setGlicemiaCap] = useState("");
  const [otrosDatosExplora, setOtrosDatosExplora] = useState("");
  const [labsEstudios, setLabsEstudios] = useState("");
  const [estadoIMC, setEstadoIMC] = useState("");
  const [estadoSaturaOx, setEstadoSaturaOx] = useState("");
  // ------------------------------------------------------------ HISTORICOS DE EXPLORACION ------------------------------
  const [frecCardiacaEx, setFrecCardiacaEx] = useState("");
  const [frecRespEx, setFrecRespEx] = useState("");
  const [tempEx, setTempEx] = useState("");
  const [presionArtEx, setPresioArtEx] = useState("");
  const [pesoEx, setPesoEx] = useState("");
  const [tallaEx, setTallaEx] = useState("");
  const [imcEx, setImcEx] = useState("");
  const [saturaOxEx, setSaturaOxEx] = useState("");
  const [glicemiaCapEx, setGlicemiaCapEx] = useState("");
  const [otrosDatosExploraEx, setOtrosDatosExploraEx] = useState("");
  const [labsEstudiosEx, setLabsEstudiosEx] = useState("");
  const [estadoIMCEx, setEstadoIMCEx] = useState("");
  const [estadoSaturaOxEx, setEstadoSaturaOxEx] = useState("");
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> FIN DE VARIABLES DE EXPLORACION FISICA

  const [checkHosp, setCheckHosp] = useState(0);
  const [dataNotaEvol, setDataNotaEvol] = useState("");
  const [api, contextHolder] = notification.useNotification();

  const [dataSesiones, setDataSesiones] = useState([]);
  const [listDiag, setListDiag] = useState([]);
  const [diagnosticoNom, setDiagnosticoNom] = useState("");
  const [openModalDiag, setModalOpenDiag] = useState(false);
  const [valor, setValor] = useState("");
  const [dataGrupos, setDataGrupos] = useState([]);
  const [idGpo, setIdGpo] = useState("");
  const [dataMarcadores, setDataMarcadores] = useState([
    { label: "--SELECCIONA--", value: "" },
  ]);
  const [idMarcador, setIdMarcador] = useState("");

  const modal = useRef();

  const closeModalDiag = () => {
    setModalOpenDiag(false);
  };

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSelectDiag = (idDiag, diag) => {
    setIdDiag((prev) => [...prev, idDiag]);
    setDiagnosticoNom((prev) => [...prev, diag]);
    setDiagnostico((prev) => [...prev, diag]);
    setModalOpenDiag(false);
  };

  const getExpedAnt = async (idPac) => {
    await getExpedAnterior(idNegocio, idPac)
      .then((res) => {
        setLinkDoc(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      width: 450,
    },
    {
      title: "...",
      dataIndex: "x",
      align: "center",
      width: 80,
      render: (text, record) => (
        <Button
          size="xs"
          startIcon={<FaArrowRight></FaArrowRight>}
          appearance="primary"
          onClick={() => handleSelectDiag(record.idDiag, record.nombre)}
        >
          Seleccionar
        </Button>
      ),
    },
  ];

  const loadServicios = async () => {
    await getCatServicios(idNegocio)
      .then(async (response) => {
        setListServicios(response);
        await loadHorarios(idServicio).then(async (res) => {
          setHorario(hora);
          await getDatosPaciente(idNegocio, idPaciente).then((res) => {
            setPaciente(res.paciente);
          });
        });
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  // Callback function to receive data from the child
  const handleDataFromChild = (data) => {
    setDataNotaEvol(data);
  };

  const getAntecedentesPaciente = async (idPac) => {
    // setIdPaciente(idPac);
    await getAntecedentes(idNegocio, idPac)
      .then(async (response) => {
        setListaAnteced(response);
        await getExploraItems().then(async (res) => {
          setInicioDisabled(true);
          await getListaCitas(idPac);
          if (appConfigParams.mostrarExpedAnt === 1) {
            getExpedAnt(idPac);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getExploraItems = async () => {
    await getExploraFisicaItems(idNegocio)
      .then((response) => {
        response.forEach((element) => {
          if (element.idGpo === 1) {
            const originalString = element.items;
            setValueGpo1(originalString.join(", "));
          }
          if (element.idGpo === 2) {
            const originalString2 = element.items;
            setValueGpo2(originalString2.join(", "));
          }
          if (element.idGpo === 3) {
            const originalString3 = element.items;
            setValueGpo3(originalString3.join(", "));
          }
          if (element.idGpo === 4) {
            const originalString4 = element.items;
            setValueGpo4(originalString4.join(", "));
          }
        });
        setdataSignos(response);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getListaCitas = async (idPac) => {
    await getHistoricoCitas(idNegocio, idPac).then(async (res) => {
      setListCitas(res);
      await getSesionesHemo(idNegocio, idPac).then((res) => {
        setDataSesiones(res);
      });
    });
  };

  const getDatosCitaPaciente = async (fecha, idPac) => {
    await getDatosCita(idNegocio, idPac, fecha)
      .then((response) => {
        setIdConsulta(response.idConsulta);
        setMotivoConsEx(response.motivoCons);
        setDiagnosticoCitaEx(response.diagnostico);
        setTratamientoCitaEx(response.tratamiento);
        setIndicacionesCitaEx(response.indicaciones);

        // DATOS DE EXPLORACION FISICA
        setFrecCardiacaEx(response.dataSignos.frecCardiaca);
        setFrecRespEx(response.dataSignos.frecResp);
        setTempEx(response.dataSignos.temp);
        setPresioArtEx(response.dataSignos.presionArt);
        setPesoEx(response.dataSignos.peso);
        setTallaEx(response.dataSignos.talla);
        setImcEx(response.dataSignos.imc);
        setSaturaOxEx(response.dataSignos.saturaOx);
        setGlicemiaCapEx(response.dataSignos.glicemiaCap);
        setOtrosDatosExploraEx(response.dataSignos.otrosDatosExp);
        setLabsEstudiosEx(response.dataSignos.labsEstudios);
        setObservaCitaEx(response.anotaciones);
        setdataSignosEx(response.dataExplora);
        setMotivoEx(response.motivo);
        getDocsCitaConsulta(response.idConsulta);
        const titulo = `Consulta / Fecha: ${fecha}`;
        setTituloDrawer(titulo);
        setOpen(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const loadCatDiagnosticos = async () => {
    if (!filtroDiag) {
      return;
    }

    await getCatDiagnosticos(filtroDiag)
      .then((res) => {
        setListDiag(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const getDocsCitaConsulta = async (idConsulta) => {
    await getDocsCita(idNegocio, idConsulta)
      .then((response) => {
        let doc = [];

        response.forEach((element) => {
          doc.push({ doc: element.NombreDoc, tipoDoc: element.tipoDoc });
        });
        setImageList(doc);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const isValidDate = (dateString) => {
    const dateObject = new Date(dateString);
    // Check if the date object is an instance of Date and not an "Invalid Date" (NaN)
    return dateObject instanceof Date && !isNaN(dateObject);
  };

  const handleAccordions = async (opc) => {
    switch (opc) {
      case 1:
        setActiveKey(1);
        setDisabledAccord2(true);
        setDisabledAccord3(true);
        setDisabledIni(false);
        break;
      case 2:
        setActiveKey(2);
        setDisabledAccord2(false);
        setDisabledAccord3(false);
        setDisabledIni(true);
        getAntecedentesPaciente(idPaciente).then((rs) => {
          loadGrupos();
        });
        break;
      default:
        break;
    }
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const handleListaCitas = (e) => {
    if (e != null) {
      let _fec = e.replace("/", "-");
      _fec = _fec.replace("/", "-");
      getDatosCitaPaciente(_fec, idPaciente);
    } else {
      setDiagnosticoCita("");
      setTratamientoCita("");
      setIndicacionesCita("");
      setObservaCita("");
      setImageList([]);
    }
  };

  const handleFileList = (e) => {
    setFileList(Array.from(e.target.files));
  };

  const save = async () => {
    setLoading(true);
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("file", file);
    });

    formData.append("id", idNegocio);
    formData.append("motivo", motivoCons);
    formData.append("fecha", fecha);
    formData.append("hora", hora);
    formData.append("espacio", espacio.noEspacio);
    formData.append("idPaciente", idPaciente);
    formData.append("idMedico", idMedico);
    formData.append("idServicio", idServicio);
    formData.append("idTipoDoc", idTipoDoc);
    formData.append("idUser", idUser);
    formData.append("diagnostico", diagnostico);
    formData.append("tratamiento", tratamiento);
    formData.append("indicaciones", indicaciones);
    formData.append("observa", observa);

    formData.append("frecCardiaca", frecCardiaca);
    formData.append("frecResp", frecResp);
    formData.append("temp", temp);
    formData.append("presionArt", presionArt);
    formData.append("peso", peso);
    formData.append("talla", talla);
    formData.append("imc", imc);
    formData.append("saturaOx", saturaOx);
    formData.append("glicemiaCap", glicemiaCap);
    formData.append("otrosDatos", otrosDatosExplora);
    formData.append("labsEstudios", labsEstudios);
    formData.append("datosExploraFis", dataSignos.length);
    var _fechaIni = fechaIni;
    if (_fechaIni) {
      _fechaIni = moment(fechaIni).format("YYYY-MM-DD");
    }
    formData.append("fechaHosp", _fechaIni);
    formData.append("notaEvol", dataNotaEvol);
    formData.append("idDiag", idDiag);

    if (dataSignos.length > 0) {
      formData.append(dataSignos[0].idGpo, valueGpo1);
      formData.append(dataSignos[1].idGpo, valueGpo2);
      formData.append(dataSignos[2].idGpo, valueGpo3);
      formData.append(dataSignos[3].idGpo, valueGpo4);
    }

    await saveConsulta(formData)
      .then((res) => {
        if (res > 0) {
          toast("La consulta se ha finalizado", "success");
          if (appConfigParams.emitirReceta === 1) {
            setModalReceta(true);
          } else {
            setTimeout(() => {
              window.location.replace("/#/App/Home/CitasMedicas");
            }, [1200]);
          }
        } else {
          setLoading(false);
          toast("Ocurrio un error al guardar la consulta", "error");
        }
      })
      .catch((error) => {
        setLoading(false);
        toast(
          "Ocurrio un error inesperado, valide su conexión a internet",
          "error",
        );
        console.log(error);
      });
  };

  const getPageMargins = (marginTop, marginRight, marginBottom, marginLeft) => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const marginTop = "55mm";
  const marginRight = "25mm";
  const marginBottom = "25mm";
  const marginLeft = "25mm";

  const handlePrint = useReactToPrint({
    documentTitle: "Receta",
    contentRef: componentRef,
    pageStyle: getPageMargins(marginTop, marginRight, marginBottom, marginLeft),
  });

  const getPageMarginsPreQX = (
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
  ) => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const marginTopPreQx = "5mm";
  const marginRightPreQx = "10mm";
  const marginBottomPreQx = "5mm";
  const marginLeftPreQx = "10mm";

  const handlePrintPreQX = useReactToPrint({
    documentTitle: "FormatoPREQX",
    contentRef: componentValorPreQX,
    pageStyle: getPageMarginsPreQX(
      marginTopPreQx,
      marginRightPreQx,
      marginBottomPreQx,
      marginLeftPreQx,
    ),
  });

  const handleClose = () => {
    window.location.replace("/#/App/Home/CitasMedicas");
  };

  const getFinalText = (text) => {
    const lines = text.split("\n");
    return (
      <div>
        {lines.map((item, index) => (
          <React.Fragment key={index}>
            {item}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const handleLoadFile = (e) => {
    console.log(e.target.files);
    if (e.target.files.length > 0) {
      setFile(e.target.files);
      saveDocument(e.target.files);
    }
  };

  const calculaIMC = async () => {
    setImc("");
    if (peso > 0 && talla > 0) {
      const resultImc = peso / ((talla / 100) * (talla / 100));
      setImc(resultImc.toFixed(1));
      await getEstadoIMC(resultImc.toFixed(1))
        .then((response) => {
          setEstadoIMC(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const calculaSaturaOx = (valor) => {
    setSaturaOx(valor);
    let result = "";
    if (valor > 99) setEstadoSaturaOx("Requiere atención");
    else {
      if (valor > 0) {
        listaSaturaOx.forEach(function (x) {
          if (x.valorMin <= valor && x.valorMax >= valor) {
            result = x.estado;
          }
        });
        setEstadoSaturaOx(result);
      } else {
        setEstadoSaturaOx("");
      }
    }
  };

  const handleValueSesion = (e) => {
    if (e === null) {
      return;
    }
    var _data = e;
    var sesion = _data.split("-")[0];
    var folio = _data.split("-")[1];

    if (sesion === "HE") {
      window.open(
        `/#/App/Home/HojaEnfermeriaView/${folio}/${idPaciente}`,
        "_blank",
        "noopener,noreferrer",
      );
    } else {
      window.open(
        `/#/App/Home/NotaMedicaView/${folio}/${idPaciente}`,
        "_blank",
        "noopener,noreferrer",
      );
    }
  };

  const openLaboratorios = () => {
    window.open(
      `/#/App/Home/Laboratorios/${idPaciente}/${paciente}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const expandeSignosExplora = () => {
    setPanelExpandedSignos(true);
  };

  const handleOpenNotaEvol = async () => {
    await getDatosCitaAnterior(idNegocio, idPaciente, idAnteced)
      .then((res) => {
        setResult(res);
        modal.current.open();
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const loadGrupos = async () => {
    await getGruposLab(idNegocio)
      .then(async (res) => {
        setDataGrupos(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const loadMarcadores = async (idGpo) => {
    setIdGpo(idGpo);
    setDataMarcadores([{ label: "--SELECCIONA--", value: "" }]);
    await getMarcadoresLab(idNegocio, idGpo)
      .then((res) => {
        setDataMarcadores((prev) => [...prev, ...res]);
        setIdMarcador("");
        setValor("");
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleChangeValueExplora = (e, idGpo) => {
    if (idGpo === 1) {
      setValueGpo1(e);
    }
    if (idGpo === 2) {
      setValueGpo2(e);
    }
    if (idGpo === 3) {
      setValueGpo3(e);
    }
    if (idGpo === 4) {
      setValueGpo4(e);
    }
  };

  const handleChangecheckPreQx = (value, checked) => {
    setMostrarModalPreQx(checked);
  };

  const saveDocument = async (f) => {
    const formData = new FormData();
    formData.append("id", idNegocio);
    formData.append("idPaciente", idPaciente);
    formData.append("file", f[0]);
    formData.append("idUser", idUser);
    formData.append("expedAnt", 1);

    await saveDoc(formData)
      .then((res) => {
        if (res.data !== "") {
          toast("El documento se ha cargado de forma correcta", "success");
          setLinkDoc(res.data);
        } else {
          toast("Ocurrio un error al subir el documento", "error");
          setLinkDoc("#");
        }
      })
      .catch((error) => {
        toast(
          "Ocurrio un error inesperado, valide su conexión a internet",
          "error",
        );
        console.log(error);
      });
  };

  const checkReqHosp = (e) => {
    if (e.target.checked) {
      setCheckHosp(1);
    } else {
      setCheckHosp(0);
    }
  };

  const openWindowFrame = () => {
    const urlToEmbed = `/Docs/Negocios/${idNegocio}/${idPaciente}/${linkDoc}`; // PDF
    const windowFeatures = "width=1200,height=900,resizable=yes,scrollbars=yes";
    const newWindow = window.open("", "_blank", windowFeatures);

    if (newWindow) {
      newWindow.document.open();
      newWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <style>
              iframe {
                      width: 98vw;  /* 100% of the viewport width */
                      height: 98vh; /* 100% of the viewport height */
                      border: none;  /* Removes default border */
                      display: block;
                  }
            <style>
            <head>
                <title>Visor PDF</title>
                <style>body { margin: 0; padding: 0; }</style>
            </head>
            <body>
                <iframe src="${urlToEmbed}" width="100%" height="100%" frameborder="0"></iframe>
            </body>
            </html>
        `);
      newWindow.document.close();
    }
  };

  const handleOpenModalDiagnosticos = () => {
    setFiltroDiag("");
    setListDiag([]);
    setModalOpenDiag(true);
  };

  const getPaciente = async (e) => {
    setHorario(e);
    await getPacienteProgramado(idNegocio, idServicio, e).then((res) => {
      // setIdPaciente(res.idPaciente);
      setPaciente(res.nombre);
    });
  };

  const saveMarcador = async () => {
    const data = {
      IdConsultorio: idNegocio,
      IdConsulta: 0,
      IdGpo: idGpo,
      IdMarcador: idMarcador,
      Valor: valor,
      IdMedico: idMedico,
      IdPaciente: idPaciente,
    };

    await addMarcador(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Marcador",
            "Se guardo el valor del laboratorio.",
          );
          const selectedItem = dataMarcadores.find(
            (item) => item.value === idMarcador,
          );
          const marcador = selectedItem.label;
          var _valor = valor;
          if (valor === "-1") {
            _valor = "NEG";
          }
          if (valor === "+1") {
            _valor = "POS";
          }
          setLabsEstudios((prev) => [prev, `${marcador}(${_valor})`]);
          loadGrupos().then((res) => {
            loadMarcadores(idGpo).then((res) => {
              setValor("");
            });
          });
        } else {
          errorNotificaction(
            "Error_addMarcador",
            "Ocurrio un error al agregar el valor.",
          );
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const loadHorarios = async (e) => {
    // setIdServicio(e);
    // setIdPaciente(0);
    setPaciente("");
    setHorario("0");
    setListHorarios([{ label: "--SELECCIONA--", value: "0" }]);

    await getHorariosDia(idNegocio, idMedico, e, fecha).then((res) => {
      setListHorarios((prev) => [...prev, ...res]);
    });
  };

  const handleCellChange = async (props) => {
    const idNegocio = JSON.parse(localStorage.getItem("auth")).id;

    const data = {
      opc: props.opc,
      id: idNegocio,
      idPaciente: idPaciente,
      idAnteced: props.idAnteced,
      noItem: props.id,
      valorado: props.opc === "resp" ? props.valor : "",
      obs: props.opc === "resp" ? "" : props.texto,
    };

    await saveItem(data)
      .then(async (res) => {
        toast("Se ha registrado la información.", "success");
      })
      .catch((error) => {
        toast("Ocurrio un error al guardar.", "error");
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    if (!initialized.current) {
      initialized.current = true;
      loadServicios();
    }
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageList]);

  return (
    <>
      <title>Citas Médicas / Consulta</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          {
            title: (
              <a
                href="/#/App/Home/CitasMedicas"
                style={{ textDecoration: "none" }}
              >
                Citas (Médicas)
              </a>
            ),
          },
          { title: "Consulta" },
        ]}
        selectedKey={"Consulta"}
      >
        {contextHolder}
        <div className="row mb-3">
          <Text size={"sm"}>
            Fecha: {moment(fecha).format("dddd, DD MMMM YYYY")} / Horario de la
            Cita: {hora}{" "}
          </Text>
        </div>
        <div className="row mb-3">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <Text size={"sm"}>Servicio</Text>
            <SelectPicker
              data={listServicios}
              value={idServicio}
              disabled
              searchable={false}
              block
              placeholder="Selecciona un servicio..."
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <Text size={"sm"}>Horario de la cita</Text>
            <Input style={{ textAlign: "center" }} readOnly value={hora} />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <Text size={"sm"}>Paciente</Text>
            <Input readOnly value={paciente} />
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <br></br>
            <Button
              block
              startIcon={<LucideNotebookPen size={16}></LucideNotebookPen>}
              appearance="primary"
              loading={loading}
              disabled={inicioDisabled}
              onClick={() => handleAccordions(2)}
            >
              Comenzar
            </Button>
          </div>
        </div>

        <Accordion activeKey={activeKey} bordered onSelect={setActiveKey}>
          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ACORDION DE LOS DATOS GENERALES */}

          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> REGISTRO ANTERIOR DE HISTORIA CLINICA  <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
          {appConfigParams.mostrarExpedAnt === 1 ? (
            <Accordion.Panel
              header="Registro anterior de Historia Clínica"
              key="Reg_Ant_HS"
              bordered
              disabled={disabledAccord2}
              eventKey={6}
            >
              <div className="row">
                <div
                  className="col-lg-3 col-md-3 col-sm-3"
                  style={{ padding: "10px" }}
                >
                  <Text>Cargar documento...</Text>
                  <input
                    className="form-control"
                    type="file"
                    id="fileHS"
                    accept=".pdf"
                    onChange={(e) => handleLoadFile(e)}
                    multiple
                  />
                </div>
                <div
                  className="text-left col-lg-9 col-md-9 col-sm-9"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {linkDoc === "" ? (
                    "Sin archivo..."
                  ) : (
                    <Button appearance="link" onClick={() => openWindowFrame()}>
                      <AttachmentIcon size={25} />
                      &nbsp; {linkDoc}
                    </Button>
                  )}
                </div>
              </div>
            </Accordion.Panel>
          ) : (
            ""
          )}
          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> HISTORIA CLINICA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
          <Accordion.Panel
            header="Historia Clínica"
            key="HistoriaClinica"
            bordered
            disabled={disabledAccord2}
            defaultExpanded={false}
            eventKey={2}
          >
            {listaAnteced.length > 0
              ? listaAnteced.map((itm, index) => {
                  return (
                    <div key={`div-${index}`}>
                      <Accordion.Panel
                        header={`${itm.nombre}`}
                        bordered
                        disabled={disabledAccord2}
                        defaultExpanded={false}
                        eventKey={2}
                        key={`accord-${index}`}
                      >
                        <Table
                          bordered
                          hover
                          responsive
                          key={`tbl-${index}`}
                          style={{
                            width: "100%",
                            cellPadding: "5",
                            cellSpacing: "10",
                            fontSize: isMobile ? "10px" : "16px",
                          }}
                          cellPadding={10}
                          cellSpacing={10}
                        >
                          <thead key={`headers-${index}`}>
                            <tr
                              key={`fila-${index}`}
                              style={{
                                borderBottom: "solid 2px",
                                paddingBottom: "15",
                              }}
                            >
                              {isMobile ? (
                                ""
                              ) : (
                                <th
                                  key={`header0-${index}`}
                                  style={{ textAlign: "center", width: "5%" }}
                                >
                                  <b>#</b>
                                </th>
                              )}
                              <th
                                key={`header1-${index}`}
                                style={{ width: "30%" }}
                              >
                                <b>Item</b>
                              </th>
                              <th
                                key={`header2-${index}`}
                                style={{ width: "15%", textAlign: "center" }}
                              >
                                <b>Respuesta</b>
                              </th>
                              <th
                                key={`header3-${index}`}
                                style={{ width: "50%" }}
                              >
                                <b>Observaciones</b>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {itm.detalles.map((item, ix) => {
                              return (
                                <tr key={`fila-${ix}`}>
                                  {isMobile ? (
                                    ""
                                  ) : (
                                    <td
                                      key={`celda1-${ix}`}
                                      style={{ textAlign: "center" }}
                                    >
                                      {item.id}
                                    </td>
                                  )}
                                  <td key={`celda2${index}-${ix}`}>
                                    {item.Item}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <select
                                      key={`select-${ix}`}
                                      style={{ border: "none" }}
                                      onChange={(e) =>
                                        handleCellChange({
                                          opc: "resp",
                                          idAnteced: item.idAnteced,
                                          id: item.id,
                                          valor: e.target.value,
                                        })
                                      }
                                    >
                                      <option
                                        key={`opt-select-SinVal-${ix}-${index}`}
                                        value=""
                                        selected={
                                          item.valorado === "" ? true : false
                                        }
                                      ></option>
                                      <option
                                        key={`opt-select-SI-${ix}-${index}`}
                                        value="SI"
                                        selected={
                                          item.valorado === "SI" ? true : false
                                        }
                                      >
                                        SI
                                      </option>
                                      <option
                                        key={`opt-select-NO-${ix}-${index}`}
                                        value="NO"
                                        selected={
                                          item.valorado === "NO" ? true : false
                                        }
                                      >
                                        NO
                                      </option>
                                    </select>
                                  </td>
                                  <td key={`obs-${index}${ix}`}>
                                    <Textarea
                                      autosize
                                      size="small"
                                      defaultValue={item.observacion}
                                      style={{
                                        fontSize: isMobile ? "10px" : "14px",
                                        border: "none",
                                      }}
                                      onBlur={(e) =>
                                        handleCellChange({
                                          opc: "obs",
                                          idAnteced: item.idAnteced,
                                          id: item.id,
                                          texto: e.target.value,
                                        })
                                      }
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </Accordion.Panel>
                    </div>
                  );
                })
              : ""}
          </Accordion.Panel>

          {/* ************************************************************************** BLOQUE DE INICIO DE LA CONSULTA ************************************************** */}
          <Accordion.Panel
            header={`Consulta`}
            key="Consulta"
            bordered
            disabled={disabledAccord2}
            eventKey={3}
          >
            <Form>
              <Card shaded>
                <Card shaded style={{ padding: "15px" }}>
                  <div className="row mb-2">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <SelectPicker
                        searchable={false}
                        data={listCitas}
                        style={{ width: "100%", fontWeight: "600" }}
                        block
                        placeholder="--CITAS ANTERIORES--"
                        onChange={(e) => handleListaCitas(e)}
                      />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <SelectPicker
                        data={dataSesiones}
                        groupBy="grupo"
                        labelKey="name"
                        valueKey="dataSesion"
                        onChange={(e) => handleValueSesion(e)}
                        placeholder="--HOJAS DE ENFERMERÍA Y NOTAS MÉDICAS--"
                        block
                      />
                    </div>
                    <div className="col-lg-3 col-md-3 cols-m-3">
                      <Textarea
                        rows={3}
                        maxLength={500}
                        placeholder="Motivo de la consulta"
                        value={motivoCons}
                        onChange={(e) => setMotivoCons(e)}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <IconButton
                        appearance="primary"
                        icon={<ChangeListIcon />}
                        onClick={() => handleOpenNotaEvol()}
                      >
                        Nota de evolución
                      </IconButton>
                    </div>
                  </div>
                </Card>
                {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> SIGNOS VITALES Y EXPLORACIÓN FISICA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
                {appConfigParams.mostrarExplora === 1 ? (
                  <div className="row mb-1">
                    <div className="col">
                      <Panel
                        bordered
                        header="Signos Vitales y Exploración Física"
                        expanded={true}
                        key="panelSignosVitales"
                        onClick={expandeSignosExplora}
                      >
                        <div className="row mb-2">
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Peso</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={peso}
                              onChange={(e) => setPeso(e)}
                            />
                            <span style={{ fontSize: "12px" }}>
                              En kilogramos
                            </span>
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Talla</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={talla}
                              onChange={(e) => setTalla(e)}
                            />
                            <span style={{ fontSize: "12px" }}>
                              En centimetros
                            </span>
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">IMC</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={imc}
                              onChange={(e) => setImc(e)}
                              onFocus={calculaIMC}
                            />
                            <span style={{ fontSize: "12px", color: "blue" }}>
                              {estadoIMC}
                            </span>
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm" title="Presión arterial">
                              TA
                            </Text>
                            <Inpt
                              style={{ textAlign: "center" }}
                              value={presionArt}
                              onChange={(e) => setPresioArt(e)}
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">FC</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={frecCardiaca}
                              onChange={(e) => setFrecCardiaca(e)}
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">FR</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={frecResp}
                              onChange={(e) => setFrecResp(e)}
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">
                              <b>T</b>emperatura
                            </Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={temp}
                              onChange={(e) => setTemp(e)}
                            />
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">
                              Sp<b>O</b>2
                            </Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={saturaOx}
                              onChange={(e) => calculaSaturaOx(e)}
                            />
                            <span style={{ fontSize: "12px", color: "blue" }}>
                              {estadoSaturaOx}
                            </span>
                          </div>
                          <div className="text-center col-lg-1 col-md-1 col-sm-1">
                            <Text size="sm">Glicemia capilar</Text>
                            <NumberInput
                              controls={false}
                              style={{ textAlign: "center" }}
                              value={glicemiaCap}
                              onChange={(e) => setGlicemiaCap(e)}
                            />
                            <span style={{ fontSize: "12px" }}>mg/dl.</span>
                          </div>
                          <div className="col-lg-3 col-md-3 col-sm-3">
                            <Text size="sm">Otros datos</Text>
                            <Inpt
                              as="textarea"
                              placeholder="Generales de la exploración..."
                              rows={3}
                              value={otrosDatosExplora}
                              onChange={(e) => setOtrosDatosExplora(e)}
                            />
                          </div>
                        </div>
                        {dataSignos.length > 0 ? (
                          <div className="row">
                            <div className="col-lg-3 col-md-3 col-sm-3">
                              <Card key={`card1`}>
                                <Card.Header
                                  style={{ fontSize: "12px" }}
                                  key={`cardHeader-1`}
                                >
                                  {dataSignos[0].nombre}
                                </Card.Header>
                                <Card.Body key={`cardBody-1`}>
                                  <Textarea
                                    key={`gpo1`}
                                    rows={4}
                                    value={valueGpo1}
                                    onChange={(e) =>
                                      handleChangeValueExplora(
                                        e,
                                        dataSignos[0].idGpo,
                                      )
                                    }
                                  />
                                </Card.Body>
                              </Card>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3">
                              <Card key={`card2`}>
                                <Card.Header
                                  style={{ fontSize: "12px" }}
                                  key={`cardHeader-2`}
                                >
                                  {dataSignos[1].nombre}
                                </Card.Header>
                                <Card.Body key={`cardBody-2`}>
                                  <Textarea
                                    key={`gpo2`}
                                    rows={4}
                                    value={valueGpo2}
                                    onChange={(e) =>
                                      handleChangeValueExplora(
                                        e,
                                        dataSignos[1].idGpo,
                                      )
                                    }
                                  />
                                </Card.Body>
                              </Card>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3">
                              <Card key={`card-3`}>
                                <Card.Header
                                  style={{ fontSize: "12px" }}
                                  key={`cardHeader-3`}
                                >
                                  {dataSignos[2].nombre}
                                </Card.Header>
                                <Card.Body key={`cardBody-3`}>
                                  <Textarea
                                    key={`gpo3`}
                                    rows={4}
                                    value={valueGpo3}
                                    onChange={(e) =>
                                      handleChangeValueExplora(
                                        e,
                                        dataSignos[2].idGpo,
                                      )
                                    }
                                  />
                                </Card.Body>
                              </Card>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3">
                              <Card key={`card-4`}>
                                <Card.Header
                                  style={{ fontSize: "12px" }}
                                  key={`cardHeader-4`}
                                >
                                  {dataSignos[3].nombre}
                                </Card.Header>
                                <Card.Body key={`cardBody-4`}>
                                  <Textarea
                                    key={`gpo4`}
                                    rows={4}
                                    value={valueGpo4}
                                    onChange={(e) =>
                                      handleChangeValueExplora(
                                        e,
                                        dataSignos[3].idGpo,
                                      )
                                    }
                                  />
                                </Card.Body>
                              </Card>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </Panel>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> LABORATORIOS Y/O ESTUDIOS DE GABINETE  <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<*/}
                <div className="row mb-3">
                  <div className="col">
                    <Panel
                      bordered
                      header="Laboratorios y/o Estudios de Gabinete"
                      defaultExpanded
                      key="panelLabsEstud"
                    >
                      <div className="row mb-2">
                        <div className="col-lg-2 col-md-2 col-sm-2">
                          <Text>Grupo</Text>
                          <SelectPicker
                            data={dataGrupos}
                            value={idGpo}
                            block
                            searchable={false}
                            placeholder="--SELECCIONA--"
                            onChange={(e) => loadMarcadores(e)}
                          />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3">
                          <Text>Marcador</Text>
                          <SelectPicker
                            data={dataMarcadores}
                            value={idMarcador}
                            block
                            searchable={false}
                            placeholder="--SELECCIONA--"
                            onChange={(e) => setIdMarcador(e)}
                          />
                        </div>
                        <div className="text-center col-lg-1 col-md-1 col-sm-1">
                          <Text>Valor</Text>
                          <Input
                            value={valor}
                            disabled={
                              idGpo !== "" && idMarcador !== "" ? false : true
                            }
                            style={{ textAlign: "center" }}
                            onChange={(e) => setValor(e.target.value)}
                          />
                        </div>
                        <div className="col-lg-1 col-md-1 col-sm-1">
                          <br></br>
                          <Btn
                            disabled={valor !== "" ? false : true}
                            block
                            type="primary"
                            icon={<FaPlusCircle></FaPlusCircle>}
                            onClick={saveMarcador}
                          >
                            Agregar
                          </Btn>
                        </div>
                        <div className="col-lg-5 col-md-5 col-sm-5">
                          <Btn
                            size="small"
                            type="primary"
                            block
                            icon={<SearchIcon size={14} />}
                            onClick={openLaboratorios}
                          >
                            Ver tabla de laboratorios
                          </Btn>
                          <Inpt
                            as="textarea"
                            style={{ width: "100%" }}
                            rows={4}
                            placeholder="Escriba aquí los resultados de los laboratorio o estudios..."
                            value={labsEstudios}
                            onChange={(e) => setLabsEstudios(e)}
                          />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-lg-2 col-md-2 cols-sm-2">
                          <input
                            className="form-control-sm"
                            type="file"
                            id="file"
                            onChange={(e) => handleFileList(e)}
                            multiple
                          />
                        </div>
                        <div
                          className="col-lg-10 col-md-10 col-sm-10"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {fileList.length > 0 && (
                            <Breadcrumb size="lg">
                              {fileList.map((file, index) => (
                                <Breadcrumb.Item key={index}>
                                  {file.name}
                                </Breadcrumb.Item>
                              ))}
                            </Breadcrumb>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <Inpt
                            as="textarea"
                            rows={3}
                            placeholder="Anotaciones..."
                            value={observa}
                            onChange={(e) => setObserva(e)}
                          />
                        </div>
                      </div>
                    </Panel>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Box
                      bd="1px solid var(--rs-border-primary)"
                      rounded="md"
                      mb={5}
                      style={{ padding: "10px" }}
                    >
                      <Text size="sm">
                        {" "}
                        &nbsp; <b>Nota de evolución:</b> {dataNotaEvol}
                      </Text>
                    </Box>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="text-center col">
                    <Checkbox
                      checked={checkHosp === 1 ? true : false}
                      onClick={(e) => checkReqHosp(e)}
                    >
                      <Text color={"red"}>Requiere Hospitalización</Text>
                    </Checkbox>
                  </div>
                </div>
                {checkHosp === 1 ? (
                  <div className="text-center col">
                    <CustomProvider locale={es_ES}>
                      <Text>Fecha de inicio</Text>
                      <DatePicker onChange={(e) => setFechaIni(e)} size="sm" />
                    </CustomProvider>
                  </div>
                ) : (
                  ""
                )}

                {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CIERRE DE LA CONSULTA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
                <Card.Body>
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      {/* <TextArea
                        variant="underlined"
                        rows={4}
                        value={diagnostico}
                        disabled={motivoCons.length > 0 ? false : true}
                        placeholder="Escriba el diagnostico"
                        onChange={(e) => setDiagnostico(e.target.value)}
                      /> */}
                      <InputGroup inside>
                        <TextArea
                          readOnly
                          rows={4}
                          value={diagnosticoNom}
                          style={{ color: "blue" }}
                        />
                        <InputGroup.Button
                          disabled={motivoCons.length > 0 ? false : true}
                          onClick={handleOpenModalDiagnosticos}
                        >
                          <SearchIcon />
                        </InputGroup.Button>
                      </InputGroup>
                      <span>Diagnostico (NOM-004)</span>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <TextArea
                        variant="underlined"
                        disabled={motivoCons.length > 0 ? false : true}
                        rows={4}
                        placeholder="Escriba el tratamiento"
                        onChange={(e) => setTratamiento(e.target.value)}
                      />
                      <span>Tratamiento</span>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <TextArea
                        variant="underlined"
                        disabled={motivoCons.length > 0 ? false : true}
                        rows={4}
                        placeholder="Escriba las indicaciones"
                        onChange={(e) => setIndicaciones(e.target.value)}
                      />
                      <span>Indicaciones</span>
                    </div>
                  </div>
                  <br></br>
                  {appConfigParams.mostrarFmtPreQx > 0 ? (
                    <div className="row">
                      <div
                        className="text-center col"
                        style={{
                          height: "35px",
                          lineHeight: "normal",
                          paddingTop: "0",
                        }}
                      >
                        <Checkbox onChange={handleChangecheckPreQx}>
                          Imprimir formato de <b>VALORACIÓN PRE QX</b>
                        </Checkbox>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="row">
                    <div className="col">
                      <Btn
                        type="primary"
                        disabled={idDiag.length > 0 ? false : true}
                        block
                        loading={loading}
                        icon={<LucideSave size={16}></LucideSave>}
                        onClick={() => save()}
                      >
                        Guardar
                      </Btn>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Form>
          </Accordion.Panel>
          <br></br>
          <br></br>
        </Accordion>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> DRAWER EXPEDIENTE PACIENTE */}
        <Drawer size="xxl" open={open} onClose={() => setOpen(false)}>
          <Drawer.Header>
            <Drawer.Title>
              {paciente} <br /> {tituloDrawer}
            </Drawer.Title>
          </Drawer.Header>
          <Drawer.Body>
            <Card>
              <Card.Body>
                <Text size={"md"} weight="bold">
                  Motivo de consulta
                </Text>
                {motivoEx}
              </Card.Body>
            </Card>
            {appConfigParams.mostrarExplora === 1 ? (
              <div className="row mb-1">
                <div className="col">
                  <Panel
                    bordered
                    header="Exploración Física"
                    defaultExpanded
                    key="panelExploraFisExpedinete"
                  >
                    <div className="row">
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm">Peso</Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={pesoEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm">Talla</Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={tallaEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm">IMC</Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={imcEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Presión arterial">
                          TA
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={presionArtEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Frec. Cardiaca">
                          FC
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={frecCardiacaEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Frec. Respiratoria">
                          FR
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={frecRespEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Temperatura">
                          <b>T</b>emperatura
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={tempEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Saturación de O2">
                          Sp<b>O</b>2
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={saturaOxEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm">Glicemia capilar</Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={glicemiaCapEx}
                          readOnly
                        />
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <Text size="sm">Otros datos</Text>
                        <Input
                          as="textarea"
                          placeholder="Generales de la exploración..."
                          rows={3}
                          value={otrosDatosExploraEx}
                          readOnly
                        />
                      </div>
                    </div>
                  </Panel>
                </div>
              </div>
            ) : (
              ""
            )}
            {dataSignosEx.length > 0 ? (
              <div className="row mb-2">
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Card key={`card1-Ex`}>
                    <Card.Header
                      style={{ fontSize: "12px" }}
                      key={`cardHeader-1-Ex`}
                    >
                      <b>{dataSignosEx[0].nombre}</b>
                    </Card.Header>
                    <Card.Body key={`cardBody-1-Ex`}>
                      <Textarea
                        key={`gpo1-Ex`}
                        rows={4}
                        readOnly
                        value={dataSignosEx[0].items[0]}
                        onChange={(e) =>
                          handleChangeValueExplora(e, dataSignosEx[0].idGpo)
                        }
                      />
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Card key={`card2-Ex`}>
                    <Card.Header
                      style={{ fontSize: "12px" }}
                      key={`cardHeader-2-Ex`}
                    >
                      <b>{dataSignosEx[1].nombre}</b>
                    </Card.Header>
                    <Card.Body key={`cardBody-2-Ex`}>
                      <Textarea
                        key={`gpo2-Ex`}
                        rows={4}
                        readOnly
                        value={dataSignosEx[1].items[0]}
                        onChange={(e) =>
                          handleChangeValueExplora(e, dataSignosEx[1].idGpo)
                        }
                      />
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Card key={`card-3-Ex`}>
                    <Card.Header
                      style={{ fontSize: "12px" }}
                      key={`cardHeader-3-Ex`}
                    >
                      <b>{dataSignosEx[2].nombre}</b>
                    </Card.Header>
                    <Card.Body key={`cardBody-3-Ex`}>
                      <Textarea
                        key={`gpo3-Ex`}
                        rows={4}
                        readOnly
                        value={dataSignosEx[2].items[0]}
                        onChange={(e) =>
                          handleChangeValueExplora(e, dataSignosEx[2].idGpo)
                        }
                      />
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Card key={`card-4-Ex`}>
                    <Card.Header
                      style={{ fontSize: "12px" }}
                      key={`cardHeader-4-Ex`}
                    >
                      <b>{dataSignosEx[3].nombre}</b>
                    </Card.Header>
                    <Card.Body key={`cardBody-4-Ex`}>
                      <Textarea
                        key={`gpo4-Ex`}
                        rows={4}
                        readOnly
                        value={dataSignosEx[3].items[0]}
                        onChange={(e) =>
                          handleChangeValueExplora(e, dataSignosEx[3].idGpo)
                        }
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="row mb-2">
              <div className="col">
                <List style={{ flex: 1 }} bordered>
                  <List.Item>
                    <b>Diagnostico</b>
                    <br></br> {diagnosticoCitaEx}
                  </List.Item>
                  <List.Item>
                    <b>Tratamiento</b>
                    <br></br> {tratamientoCitaEx}
                  </List.Item>
                  <List.Item>
                    {appConfigParams.emitirReceta === 1 ? (
                      <IconButton
                        size="sm"
                        circle
                        onClick={() => setModalReceta(true)}
                        placement="left"
                        icon={<SearchIcon />}
                        appearance="ghost"
                      ></IconButton>
                    ) : (
                      ""
                    )}
                    &nbsp;
                    <b>Indicaciones</b>
                    <br></br>
                    {getFinalText(indicacionesCitaEx)}
                  </List.Item>
                </List>
              </div>
            </div>
            <Panel
              header={
                <Text weight="semibold">
                  Laboratorios y/o Estudios de Gabinete
                </Text>
              }
              bordered
            >
              <div className="row mb-3">
                <div className="col-lg-11 col-md-11 col-sm-11">
                  <TextArea
                    style={{ width: "100%" }}
                    rows={3}
                    placeholder="Escriba aquí los resultados de los laboratorio o estudios..."
                    value={labsEstudiosEx}
                    readOnly
                  />
                </div>
                <div className="col-lg-1 col-md-1 col-sm-1">
                  <br></br>
                  <Btn type="primary" block icon={<SearchIcon />}>
                    Ver tabla
                  </Btn>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4">
                  {imageList.length > 0 ? (
                    <Carousel
                      autoplay
                      autoplayInterval={4000}
                      shape="bar"
                      height={120}
                    >
                      {imageList.map((el, index) => {
                        return (
                          <div key={index}>
                            <br></br>
                            <ul>
                              <a
                                style={{ color: "white" }}
                                href={`Unidades/${idNegocio}/Expedientes/${idPaciente}/Consultas/${idConsulta}/${el.doc}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {el.doc}
                              </a>
                            </ul>
                          </div>
                        );
                      })}
                    </Carousel>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-8 col-lg-md-8 col-sm-8">
                  <b>Notas</b>
                  <TextArea
                    rows={3}
                    placeholder="Anotaciones..."
                    readOnly
                    value={observaCita}
                  />
                </div>
              </div>
            </Panel>
          </Drawer.Body>
        </Drawer>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL PARA RECETA MEDICA */}
        <Modal
          size="lg"
          open={modalReceta}
          onClose={handleClose}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>Indicaciones (Receta Médica)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <hr></hr>
            <Panel>
              <div ref={componentRef}>
                <div className="row">
                  <div className="col">
                    <table style={{ width: "100%" }} border={0}>
                      <tr>
                        <td style={{ width: "50%" }}>{diagnostico}</td>
                        <td>{getFinalText(indicaciones)}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </Panel>
            <hr></hr>
          </Modal.Body>
          <Modal.Footer>
            <Button appearance="primary" onClick={handlePrint}>
              Imprimir
            </Button>
            <Button onClick={handleClose} appearance="ghost">
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> DRAWER NOTA DE EVOLUCIÓN <<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <NotaEvolucion
          ref={modal}
          idNegocio={idNegocio}
          idPaciente={idPaciente}
          paciente={paciente}
          response={result}
          onSendData={handleDataFromChild}
          tituloDrawer={"Nota de Evolución"}
        />

        {/* ************************************************************ MODAL DIAGNOSTICOS ************************************** */}
        <Modal size={"lg"} open={openModalDiag} onClose={closeModalDiag}>
          <Modal.Header>
            <Modal.Title>Catálogo de Diagnosticos</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row mb-2">
                <div className="col-lg-8 col-md-8 col-sm-8">
                  <Text>Buscar diagnostico...</Text>
                  <InputGroup inside>
                    <Input
                      value={filtroDiag}
                      onChange={(e) => setFiltroDiag(e.target.value)}
                    />
                    <InputGroup.Button onClick={() => loadCatDiagnosticos()}>
                      <SearchIcon />
                    </InputGroup.Button>
                  </InputGroup>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <TableAntd
                    columns={columns}
                    bordered
                    size="small"
                    dataSource={listDiag}
                    pagination={{ pageSize: 50 }}
                    scroll={{ y: 55 * 5 }}
                  />
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={closeModalDiag} appearance="subtle">
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </LayoutHome>
    </>
  );
};
